import '@fortawesome/fontawesome-free/css/all.css';

import '../style/Home.css';
import { useState, useEffect } from 'react';

const Home = () => {
  const house_str = `
  ____||____
 ///////////\\
///////////  \\
|    _    |  |
|[] | | []|[]|
|   | |   |  |
--------------
|  _   _  |  |
--------------`;

  const lines = house_str.split('\n');
  const [displayedLines, setDisplayedLines] = useState<string[]>([]);
  const [isBuilding, setIsBuilding] = useState(true);
  const [animationFrame, setAnimationFrame] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationFrame((prev) => (prev === 0 ? 1 : 0));

      setDisplayedLines((prev) => {
        if (isBuilding) {
          if (prev.length < lines.length) {
            return [lines[lines.length - 1 - prev.length], ...prev];
          } else {
            setIsBuilding(false);
            return prev;
          }
        } else {
          if (prev.length > 0) {
            return prev.slice(0, -1);
          } else {
            setIsBuilding(true);
            return prev;
          }
        }
      });
    }, 300);

    return () => clearInterval(interval);
  }, [isBuilding, lines]);

  return (
    <>
      <div className='home-container'>
        <div className='title-components'>
          <div className='house-animation-container'>
            {isBuilding ? (
              <i
                className={`fa-solid fa-hammer hammer hammer-frame-${animationFrame}`}
              />
            ) : (
              <i
                className={`fa-solid fa-angles-up angles-up angles-up-frame-${animationFrame}`}
              />
            )}
            <pre>{displayedLines.join('\n')}</pre>
          </div>

          <div>
            <div className='title'>REM</div>
            <div className='subtitle'>
              A <i style={{ color: '#ff5757' }}>Charese</i> product
            </div>
            <div className='tagline'>Managing your own property made easy.</div>
          </div>
        </div>

        <div className='separator-div-container'>
          <div className='separator-div'></div>
        </div>

        {/* <div>Explore your local services</div> */}

        <div className='home-who-we-are'>
          <h2>Who are we?</h2>
          <div className='who-we-are-content'>
            <div className='who-we-are-card'>
              <h3>Our Mission</h3>
              <p>
                <b className='charese-rem'>Charese REM</b> is a rental
                management platform built to make it easier for landlords and
                tenants to work well together.
              </p>
            </div>

            <div className='who-we-are-card'>
              <h3>The Problem We Solve</h3>
              <p>
                Managing a rental often means juggling messages, documents,
                maintenance requests, and service providers across too many
                tools. Important details get lost, follow-ups take time, and
                small issues can turn into bigger ones.{' '}
                <b className='charese-rem'>Charese REM</b> brings these everyday
                parts of renting into one place, so communication stays clear
                and responsibilities are easier to manage.
              </p>
            </div>

            <div className='who-we-are-card'>
              <h3>What We Offer</h3>
              <p>
                The platform helps landlords and tenants connect, track
                maintenance requests, organize rental information, and access
                third-party services such as tenant screening and local
                maintenance professionals. Everything is designed to be
                transparent, consent-based, and easy to use for the people
                involved.
              </p>
            </div>

            <div className='who-we-are-card'>
              <h3>Our Responsibility</h3>
              <p>
                <b className='charese-rem'>Charese REM</b> provides tools to
                support rental relationships. We do not act as a rental
                brokerage, make leasing decisions, or give legal or financial
                advice. All rental decisions remain with the landlord, and
                personal information is handled responsibly and in line with
                applicable privacy laws.
              </p>
            </div>

            <div className='who-we-are-card'>
              <h3>Who It's For</h3>
              <p>
                <b className='charese-rem'>Charese REM</b> is built for
                independent landlords, small property owners, and tenants who
                want a more organized, modern rental experience without the
                complexity of traditional property management.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
